import type { JSX } from "react";
import SettingsPageHeader from "@/components/molecules/SettingsPageHeader";
import stripe from "../../../assets/images/stripe.png";
import firebase from "../../../assets/images/firebase.png";
import { Setting2 } from "iconsax-react";

interface Integration {
  id: number;
  name: string;
  image: string;
  status: string;
  icon: JSX.Element;
}

const MOCK_INTEGRATIONS: Integration[] = [
  {
    id: 1,
    name: "Payment Gateway",
    image: stripe,
    status: "Connected on Aug 15, 2025",
    icon: <Setting2 size={20} variant="Bold" color="#fff" />,
  },
  {
    id: 1,
    name: "Push Notifications",
    image: firebase,
    status: "Connected on Aug 15, 2025",
    icon: <Setting2 size={20} variant="Bold" color="#ffff" />,
  },
];

const IntegrationSection = ({ integration }: { integration: Integration }) => {
  return (
    <div className="text-white flex flex-col gap-3">
      <h2 className="text-base">{integration.name}</h2>
      <div className="flex items-center justify-between p-4 border-1 border-dark-20">
        <div className="flex items-center gap-4">
          <p>
            <img src={integration.image} alt="" />
          </p>
          <span className="bg-[#113B29] text-[#3DD68C] p-1 text-xs">
            {integration.status}
          </span>
        </div>
        <div className="p-2 rounded-[5px] bg-dark-20">{integration.icon}</div>
      </div>
    </div>
  );
};

const Integrations = () => {
  return (
    <div>
      <SettingsPageHeader title="Integrations" />
      <div className=" mb-4.5 flex flex-col gap-4">
        {MOCK_INTEGRATIONS.map((integration) => (
          <IntegrationSection key={integration.id} integration={integration} />
        ))}
      </div>
    </div>
  );
};

export default Integrations;
